<template>
  <div>
    <v-layout row justify-center style="margin-top:5px;" mb-2>
        <span class="text-xs-center titleColor--text headline textoAjustado"><slot></slot></span>
      </v-layout>
  </div>
</template>

<script>
export default {
  name: 'o-common-title'
}
</script>




// WEBPACK FOOTER //
// src/components/generic/titulos/OCommonTitle.vue